import * as React from 'react';
import style from './Breadcrumbs.scss';
import ChevronRight from 'wix-ui-icons-common/ChevronRight';
import classnames from 'classnames';
import { Text } from '../../PageElements/Text';
import { NAV_TYPES } from '../../../LoggerFactory/BiAnalyticsLogger/events/consts';
import { CustomLink } from '../../PageElements/CustomLink';

export const Breadcrumbs = ({ items }) =>
  items.map(({ displayName, link }, i) => {
    const active = i === items.length - 1;

    const [pathname, hash] = link.split(/(?=#)/);

    return (
      <React.Fragment key={`${link}__frag`}>
        <li
          /* Props for SEO for the breadcrumbs */
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
        >
          <CustomLink
            key={link}
            to={{
              pathname,
              hash,
              state: { navType: NAV_TYPES.BREADCRUMBS },
            }}
            className={classnames({
              [style.active]: active,
              [style.disabled]: active,
            })}
            itemProp="item"
          >
            <Text
              dataHook={`breadcrumbs-${i}`}
              size="small"
              weight="normal"
              tagName="span"
              secondary={!active}
              itemProp="name" /* Prop for SEO for the breadcrumbs */
            >
              {displayName}
            </Text>
          </CustomLink>
          {/* SEO for the breadcrumbs */}
          <meta itemProp="position" content={`${i + 2}`} />
        </li>
        {!active && (
          <ChevronRight key={`${link}__arrow`} className={style.seprator} />
        )}
      </React.Fragment>
    );
  });
